export const AUDIT_LOGS_LIST = "AUDIT_LOGS_LIST";
export const AUDIT_LOGS_ITEM_TYPES_LIST = "AUDIT_LOGS_ITEM_TYPES_LIST";
export const AUDIT_LOGS_EVENT_TYPES_LIST = "AUDIT_LOGS_EVENT_TYPES_LIST";
export const DISPATCHER_PERFORMANCE_REPORT = "DISPATCHER_PERFORMANCE_REPORT";
